import { render } from "./svgicon.vue?vue&type=template&id=955c179a"
import script from "./svgicon.vue?vue&type=script&lang=js"
export * from "./svgicon.vue?vue&type=script&lang=js"

import "./svgicon.vue?vue&type=style&index=0&id=955c179a&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/base/svgicon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "955c179a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('955c179a', __exports__)) {
    api.reload('955c179a', __exports__)
  }
  
  module.hot.accept("./svgicon.vue?vue&type=template&id=955c179a", () => {
    api.rerender('955c179a', render)
  })

}


export default __exports__